/**
 * Wraps a control sample with a short caption for scan-friendly demos on **`/demo/ui`**.
 *
 * @param caption - Label beside the sample (localized catalog text).
 * @param sample - Control rooted under **`qz-*`** styles.
 * @returns Row element suitable for appending to a demo section.
 */
export function buildDemoRow(
  caption: string,
  sample: HTMLElement,
): HTMLElement {
  const row = document.createElement("div");
  row.className = "ui-demo__row";

  const label = document.createElement("div");
  label.className = "ui-demo__caption";
  label.textContent = caption;
  row.appendChild(label);

  const slot = document.createElement("div");
  slot.className = "ui-demo__sample";
  slot.appendChild(sample);
  row.appendChild(slot);

  return row;
}
